import { Settings } from 'luxon'

export const handleSetLocale = (
  userData,
  localeChanged = false,
  changeLocale
) => {
  if (
    userData.data &&
    userData.data.settings &&
    userData.data.settings.timeZone
  ) {
    Settings.defaultZone = userData.data.settings.timeZone
  } else {
    Settings.defaultZone = Intl.DateTimeFormat().resolvedOptions().timeZone
  }

  if (
    !localeChanged &&
    userData.data &&
    userData.data.settings &&
    userData.data.settings.language
  ) {
    changeLocale(userData.data.settings.language)
  }
}
